<template>
<div>
	<vue-form save-button-text="Add" v-on:submit="saveUser" :no-top-button="true" :working="working">
		<field label="First Name"
			col-class="col-md-4"
			v-model="payload.first_name"
			:invalid="$store.errorList.first_name">
		</field>

		<field label="Last Name"
			col-class="col-md-4"
			v-model="payload.last_name"
			:invalid="$store.errorList.last_name">
		</field>

		<field label="Email"
			col-class="col-md-4"
			v-model="payload.email"
			:invalid="$store.errorList.email">
		</field>

		<field v-if="classifications.length > 0" label="Classification"
			col-class="col-md-4"
			:params="{type:'select',options:optionify(classifications,'title')}"
			v-model="selectedClassification">
		</field>

		<alert :visible="employmentOfferSent" 
			v-on:close="employmentOfferSent = false"
			classes="alert-warning"
			:message="'A user with this email address is already on '+$store.appName+', so you can\'t add him directly to your company. An employment offer has been sent instead.'">
		</alert>
	</vue-form>

	<p>If you have a lot of employees to add, you can import them by uploading a CSV file.</p>

	<div v-if="!showImport"  class="d-flex align-items-center justify-content-between flex-wrap">
		<a href="#" v-on:click.prevent="sampleCSV">Download a CSV Template</a>

		<button v-on:click="showImport = true" class="btn btn-light">
			<i class="fa fa-upload"></i>
			Import by CSV
		</button>
	</div>
	<div v-else>
		<hr>

		<div class="d-flex justify-content-between">
			<h3>Import by CSV</h3>
			<i class="fa fa-times icon-button" v-on:click="showImport = false"></i>
		</div>

		<h4>Fields:</h4>

		<ul>
			<li>First Name</li>
			<li>Last Name</li>
			<li>Email</li>
			<li>Classification (optional)</li>
			<li>Phone: Home # (optional)</li>
			<li>Phone: Mobile (optional)</li>
			<li>Address (optional)</li>
			<li>City (optional)</li>
			<li>Province/State (optional)</li>
			<li>Postal Code/Zip (optional)</li>
			<li>Emergency Contact Name (optional)</li>
			<li>Emergency Contact Phone (optional)</li>
			<li>Emergency Contact Address (optional)</li>
		</ul>

		<p><strong>Example:</strong></p>

		<div style="overflow-x: auto;">
			<table class="spreadsheet-table mb-3">
				<tr>
					<th></th>
					<th>A</th>
					<th>C</th>
					<th>D</th>
					<th>E</th>
					<th>F</th>
					<th>G</th>
					<th>H</th>
					<th>I</th>
					<th>J</th>
					<th>K</th>
					<th>L</th>
					<th>M</th>
					<th>N</th>
				</tr>
				<tr>
					<th>1</th>
					<td>First Name</td>
					<td>Last Name</td>
					<td>Email</td>
					<td>Classification (optional)</td>
					<td>Phone: Home # (optional)</td>
					<td>Phone: Mobile (optional)</td>
					<td>Address (optional)</td>
					<td>City (optional)</td>
					<td>Province/State (optional)</td>
					<td>Postal Code/Zip (optional)</td>
					<td>Emergency Contact Name (optional)</td>
					<td>Emergency Contact Phone (optional)</td>
					<td>Emergency Contact Address (optional)</td>
				</tr>
				<tr>
					<th>2</th>
					<td>Bruce</td>
					<td>Wayne</td>
					<td>bruce@wayneenterprices.com</td>
					<td>Operator</td>
					<td>519-222-3333</td>
					<td></td>
					<td>123 Wayne Manor Rd.</td>
					<td>Gotham City</td>
					<td>Ontario</td>
					<td>B4T M4N</td>
					<td>Alfred</td>
					<td>519-222-333</td>
					<td>123 Wayne Manor Rd., Gotham City</td>
				</tr>
				<tr>
					<th>3</th>
					<td>Dick</td>
					<td>Grayson</td>
					<td>dick@wayneenterprices.com</td>
					<td>Apprentice</td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
			</table>
		</div>

		<input type="file" class="form-control mb-2 mt-2" v-on:change="uploadEmployees">
	</div>
	<hr>

	<table-list record-name='Employee'
		:fields="fields"
		:records="mutatedUsers">
	</table-list>

	<alert :visible="true"classes="alert-warning mt-2" :unclosable="true">
		<h3><i class="fa fa-question-circle"></i> Employees not receiving emails?</h3>

		<p>Sometimes the {{$store.appName}} welcome emails end up in the junk folder, or get blocked entirely by overly-aggressive mail servers. If that's the case, you can always go into an employee's profile and set a password for them manually.</p>
	</alert>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import VueForm from "@/components/VueForm"
import Alert from "@/components/Alert"

export default {
	name: "EmployeeMassInvite",
	components: {
		Field,
		TableList,
		VueForm,
		Alert
	},
	data() {
		return {
			payload: {
				first_name: "",
				last_name: "",
				email: "",
				addToCompany: true
			},
			selectedClassification: null,
			classifications: [],
			working: false,
			file: null,
			showImport: false,
			employmentOfferSent: false,
			fields: [
				{key: "fullName",label: "Full Name",type:'link'},
				{key: "email",label: "Email"},
				{key: "phone_mobile",label: "Phone #"},
				{key: "classificationName",label: "Classification"},
				{key: "employeeAdded",type:'boolean',label:"Added"}
			]
		}
	},
	computed: {
		mutatedUsers() {
			let vm = this

			return this.$store.employees.map(user => {
				user.fullName = {
					text: user.first_name+" "+user.last_name,
					link: "/employee/"+user.slug+'/profile'
				}
				user.classificationName = ""
				if ("EmployeeClassification" in user && user.EmployeeClassification.length > 0)
					user.classificationName = user.EmployeeClassification[0].title
				user.employeeAdded = true

				return user
			})
		}
	},
	methods: {
		sampleCSV() {
			this.exportToCSV("employee_import_template.csv",[
				[
					"First Name",
					"Last Name",
					"Email",
					"Classification (optional)",
					"Phone: Home # (optional)",
					"Phone: Mobile (optional)",
					"Address (optional)",
					"City (optional)",
					"Province/State (optional)",
					"Postal Code/Zip (optional)",
					"Emergency Contact Name (optional)",
					"Emergency Contact Phone (optional)",
					"Emergency Contact Address (optional)",
				]
			])
		},
		uploadEmployees(evt) {
			let vm = this

			if (evt.target.files.length > 0)
				this.file = evt.target.files[0]

			let f = this.file;

			let reader = new FileReader();

			let fileValid = true

			let allowedMimes = [
				"text/plain",
				"text/csv",
				"application/vnd.ms-excel"
			]

			//check file extension type
			if (allowedMimes.indexOf(f.type) == -1)
				vm.alertFail("Invalid file format! File must be a CSV")

			else {

				 // Closure to capture the file information.
				reader.onload = (theFile => {
					return e => {
						
						let csvObj = vm.CSVToArray(e.target.result)

						//check if last row is a blank, if so remove it
						if (csvObj[csvObj.length-1].length == 1)
							csvObj.splice(csvObj.length-1,1)

						let recordsPayload, resource, numFields

						numFields = 13

						//check appropriate number of fields per row
						csvObj.forEach(row => {
							if (row.length != numFields)
								fileValid = false
						})

						recordsPayload = csvObj.filter((row,index) => index > 0).map(row => {

							let classification = vm.classifications.find(classification => classification.title == row[3])

							let payload = {
								first_name: row[0],
								last_name: row[1],
								email: row[2],
								phone: row[4],
								phone_mobile: row[5],
								address: row[6],
								city: row[7],
								province: row[8],
								postal_code: row[9],
								emergency_contact_name: row[10],
								emergency_contact_phone: row[11],
								emergency_contact_address: row[12],
								addToCompany: true
							}

							if (classification)
								payload.EmployeeClassification = [classification.id]

							return payload
						})
						
						if (fileValid) {
							vm.spinner(true)

							let promises = []
							recordsPayload.forEach((record, index) => {
								promises.push(new Promise(resolve => {
									setTimeout(() => {
										vm.postData("User/save", record).then(resolve)
									}, index * 250)
								}))
							})

							Promise.all(promises).then(responses => {
								let cnt = 0
								let inviteCnt = 0
								let invites = []
								responses.forEach((response,index) => {
									if (response.success)
										cnt++
									else {
										//if user already exists in the system, send an employment offer instead
										if ("email" in response.errors) {
											invites.push(vm.postData("CompanyUser/offer-employment",{
												email: recordsPayload[index].email
											}))
											inviteCnt++
										}
									}
								})

								let message = cnt+" employees added!"

								if (inviteCnt > 0)
									message = cnt+" employees added directly, "+inviteCnt+" employees were already users on "+vm.$store.appName+", and have been sent employement offers to your company."

								vm.alertSaved(message)
								vm.fetchEmployees()
								vm.spinner(false)
							})
						}
						else 
							vm.alertFail("Invalid CSV format! There must be "+numFields+" fields per row.")
						
					};
				})(f);

				reader.readAsText(f);
			}
		},
		saveUser() {
			let vm = this

			this.payload.EmployeeClassification = [this.selectedClassification]

			this.employmentOfferSent = false

			this.postData("User/save",this.payload).then(response => {
				if (response.success) {
					vm.fetchEmployees()
					vm.selectedClassification = null
					vm.payload.EmployeeClassification = []
					vm.payload.first_name = ""
					vm.payload.last_name = ""
					vm.payload.email = ""
				}
				else if ("email" in response.errors) {
					vm.postData("CompanyUser/offer-employment",{email: vm.payload.email}).then(response => {
						if (response.success) {
							vm.employmentOfferSent = true
							vm.fetchEmployees()
							vm.selectedClassification = null
							vm.payload.EmployeeClassification = []
							vm.payload.first_name = ""
							vm.payload.last_name = ""
							vm.payload.email = ""
						}
					})
				}
			})
		},
		fetchClassifications() {
			let vm = this

			this.getJSON("EmployeeClassification/get").then(response => {
				if (response.success)
					vm.classifications = response.data
			})
		},
		fetchEmployees() {
			let vm = this

			this.spinner(true)

			let payload = {
				include: ["EmployeeClassification"],
				includeFormer: true
			}

			this.getJSON("User/get",payload).then(function(response) {
				vm.$store.employees = response.data

				vm.spinner(false)
			})	
		}
	},
	created() {
		this.fetchClassifications()
		this.fetchEmployees()
	}
}
</script>

<style scoped>

</style>